import { createAsyncThunk } from "@reduxjs/toolkit";
import jsonDataManager from "../../../../../Services/JSONDataManager/JSONDataManager";

import HttpsClient from "../../../../../Services/HttpsClient";
import ApiHelper from "../../../../../Services/ApiHelper";
import TestAPI from "../API/TestAPI";

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const testAPI = new TestAPI(apiHelper);

export const getTests = createAsyncThunk("test/GetTests", async (payload, getState) => {
  const state = getState.getState();
  const token = state.auth.user.token;

  const data = await testAPI.getTests(payload, token);
  return data;
});

export const createApplication = createAsyncThunk("test/CreateApplication", async (payload, { getState, dispatch }) => {
  const state = getState();
  const token = state.auth.user.token;

  await testAPI.createApplication(payload, token);

  dispatch(getTests());

  return;
});

export const updateTest = createAsyncThunk("entityList/UpdateTest", async (payload, getState) => {
  const state = getState.getState();
  const token = state.auth.user.token;

  await testAPI.updateTest(payload, token);

  const data = await testAPI.getTests({ isTest: state.test.isTest }, token);

  return data;
});

export const deleteTest = createAsyncThunk("entityList/DeleteTest", async (payload, getState) => {
  const state = getState.getState();
  const token = state.auth.user.token;
  payload.isTest = state.test.isTest;
  await testAPI.deleteTest(payload, token);

  const data = await testAPI.getTests({ isTest: state.test.isTest }, token);

  return data;
});

export const getApplicationBackup = createAsyncThunk("entityList/GetApplicationBackup", async (payload, getState) => {
  const state = getState.getState();
  const token = state.auth.user.token;

  const data = await testAPI.getApplicationBackup({ id: payload.id }, token);

  jsonDataManager.downloadJSON(data, payload.name);

  return data;
});

export const upsertLeanParameters = createAsyncThunk("entityList/UpsertLeanParameters", async (payload, getState) => {
  const state = getState.getState();
  const token = state.auth.user.token;

  await testAPI.upsertLeanParameters(payload, token);

  const data = await testAPI.getTests({ isTest: state.test.isTest }, token);

  return data;
});
